import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { GetDeviceResponse } from '../types/apis/getDevice'
import type { GetPageSeoResponse } from '../types/apis/getPageSeo'
import type { GetStyleResponse } from '../types/apis/getStyle'
import type { GetCollabResponse } from '../types/apis/getCollab'
import type { GetProductResponse } from '~/types/apis/getProduct'
import type { GetProductSeriesResponse } from '../types/apis/getProductSeries'
import type { GetSeoStaticResponse } from '~/types/apis/getSeoStatic'

export const seoRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getPageSeo(
    key: string,
    options: FetchOptions = {}
  ): Promise<GetPageSeoResponse> {
    return fetch<GetPageSeoResponse>('/v1/storefront/seo/static/' + key, {
      ...options,
      method: 'GET'
    })
  },
  async getDeviceSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetDeviceResponse> {
    return fetch<GetDeviceResponse>('/v1/storefront/seo/devices/' + slug, {
      ...options,
      method: 'GET'
    })
  },
  async getStyleSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetStyleResponse> {
    return fetch<GetStyleResponse>('/v2/storefront/seo/styles/' + slug, {
      ...options,
      method: 'GET'
    })
  },
  async getCollabSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetCollabResponse> {
    return fetch<GetCollabResponse>('/v2/storefront/seo/collabs/' + slug, {
      ...options,
      method: 'GET'
    })
  },
  async getProductSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetProductResponse> {
    return fetch<GetProductResponse>('/v2/storefront/seo/products/' + slug, {
      ...options,
      method: 'GET'
    })
  },
  async getProductSeriesSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetProductSeriesResponse> {
    return fetch<GetProductSeriesResponse>(
      '/v1/storefront/seo/product-series/' + slug,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async getSeo(
    slug: string,
    options: FetchOptions = {}
  ): Promise<GetSeoStaticResponse> {
    return fetch<GetSeoStaticResponse>('/v1/storefront/seo/static/' + slug, {
      ...options,
      method: 'GET'
    })
  }
})
